
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./App": () => {
return Promise.all([__webpack_require__.e("240"), __webpack_require__.e("92")]).then(() => (() => (__webpack_require__(935))));
},
"./Button": () => {
return __webpack_require__.e("993").then(() => (() => (__webpack_require__(168))));
},
"./CancelOrder": () => {
return Promise.all([__webpack_require__.e("240"), __webpack_require__.e("693")]).then(() => (() => (__webpack_require__(980))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };